// extracted by mini-css-extract-plugin
var _1 = "g0iQz";
export { _1 as "statusSection" }
